<template>
    <div>
        <h1>Agendar Cita por WhatsApp</h1>
        <p>
            Selecciona Fecha, Hora y Ubicación para tu cita.
        </p>
        <div class="row" v-if="cartItemCount != 0">
            <div class="col-md-7 order-2 order-lg-1">
                <form
                    action=""
                    method="post"
                    class=""
                    v-on:submit.prevent="submit"
                >
                    <div class="row">
                        <div class="form-group p-2 col-md-12">
                            <label for="time" class="form-label">Selecciona Fecha y Hora</label>
                            <input
                                class="form-control"
                                type="datetime-local"
                                name="time"
                                id="time"
                                v-model="date"
                                :min="minDateTime"
                                :max="maxDateTime"
                                required
                            />
                            <small class="text-muted">No se pueden seleccionar fechas u horas pasadas</small>
                        </div>
                        <div class="form-group p-2 col-md-12">
                            <label for="ubication" class="form-label"> 
                                Selecciona <router-link to="/puntos_de_recoleccion" class="text-primary">Punto de Recolección y Entrega</router-link>
                            </label>
                            <select name="ubication" id="ubication" v-model="ubication" class="form-select">
                                <option value="Taller Principal - Cerca de CCH Naucalpan">Taller Principal - Cerca de CCH Naucalpan</option>
                                <option value="The Laikans Barber Shop - Cuautitlán Izcalli">The Laikans Barber Shop - Cuautitlán Izcalli</option>
                                <option value="Pet Life - Tlalnepantla, Valle Dorado">Pet Life - Tlalnepantla, Valle Dorado</option>
                                <option value="NanDann Autogarage - Gustavo A. Madero">NanDann Autogarage - Gustavo A. Madero</option>
                                <option value="Torres Demet - Miguel Hidalgo">Torres Demet - Miguel Hidalgo</option>
                            </select>
                        </div>
                    </div>
                    <h5 v-if="date">
                        Cita: <b>{{ getDate(date) }}</b>
                    </h5>
                    <h5 v-if="ubication">
                        Ubicación: <b>{{ ubication }}</b>
                    </h5>
                    <br />
                    <button type="submit" class="btn btn-primary w-100" :disabled="!date">
                        Enviar por WhatsApp
                    </button>
                </form>
            </div>
            <div class="col-md-5 card order-1 order-lg-2">
                <cart style="width:100%"/>
            </div>
        </div>
        <div v-else>
            <h3 class="text-primary">Ups!</h3>
            <div class="bg-primary text-white p-3 mb-2">
                <p><b>No hay Servicios Encontrados</b></p>
                <p>Agrega un Servicio para continuar con tu Pedido.</p>
            </div>
            <div class="text-center">
                <router-link class="btn btn-secondary" to="/servicios">
                    Agregar Servicios
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Cart from "./Cart.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            wa_msg: "",
            date: "",
            order: "",
            ubication: "Taller Principal - Cerca de CCH Naucalpan",
        };
    },
    components: {
        Cart,
    },
    computed: {
        minDateTime() {
            // Obtener la fecha/hora actual en formato YYYY-MM-DDTHH:mm
            const now = new Date();
            
            // Ajustar a la zona horaria local
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        maxDateTime() {
            // Opcional: establecer una fecha máxima (ej. 1 año desde ahora)
            const nextYear = new Date();
            nextYear.setFullYear(nextYear.getFullYear() + 1);
            
            const year = nextYear.getFullYear();
            const month = String(nextYear.getMonth() + 1).padStart(2, '0');
            const day = String(nextYear.getDate()).padStart(2, '0');
            
            return `${year}-${month}-${day}T23:59`;
        }
    },
    setup() {
        const store = useStore();

        const cartItems = computed(() => store.state.cartItems);
        const cartTotalPrice = computed(() => store.getters.cartTotalPrice);
        const cartItemCount = computed(() => store.getters.cartItemCount);

        const removeFromCart = (itemId) => {
            store.commit("removeFromCart", itemId);
        };

        return { cartItems, cartTotalPrice, cartItemCount, removeFromCart };
    },
    methods: {
        toMsg() {
            if (this.date != "") {
                moment.locale("es");

                // Reiniciar el order cada vez que se genera el mensaje
                this.order = "";
                
                this.cartItems.forEach((e) => {
                    this.order += "[" + e.name + "-$" + e.price + "]%0A";
                });

                this.wa_msg =
                    "https://wa.me/525533138568?text=Hola! me gustaría agendar una cita.%0A%0A" +
                    "🗓️ *Cita:* " + moment(this.date).format("LL, h:mm a") + "%0A" +
                    "📍 *Ubicación:* " + this.ubication + "%0A%0A" +
                    "🛠️ *Servicio(s):*%0A%0A" +
                    this.order +
                    "%0A%0A💰 *Total:* $" + this.cartTotalPrice +
                    "%0A%0A¿Está disponible a esa hora y lugar?";

                return this.wa_msg;
            }
        },

        getDate(date) {
            if (!date) return "";
            moment.locale("es");
            return moment(date).format("LL, h:mm a");
        },
        submit() {
            if (this.date) {
                window.location.href = this.toMsg();
            }
        },
    },
    mounted() {
        // Opcional: establecer la fecha por defecto como la hora actual redondeada a los próximos 30 minutos
        const now = new Date();
        now.setMinutes(Math.ceil(now.getMinutes() / 30) * 30);
        now.setSeconds(0);
        
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        this.date = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
};
</script>

<style scoped>
h1 {
    font-size: 7vmin;
}
.form-label {
    font-weight: bold;
    margin-top: 10px;
    display: block;
}
.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
small.text-muted {
    display: block;
    margin-top: 5px;
}
</style>